import { useEffect } from 'react';
import { sessionService } from '../services/session.service';

export function useSessionTracking(step: number, formData?: { name?: string; email?: string }) {
  // Track step changes
  useEffect(() => {
    const stepNames = {
      1: 'dados-pessoais',
      2: 'dados-filhos',
      3: 'endereco',
      4: 'pagamento',
    };

    const stepName = stepNames[step as keyof typeof stepNames] || `step-${step}`;
    sessionService.updateCurrentStep(stepName);
  }, [step]);

  // Track user info when form data changes
  useEffect(() => {
    if (formData?.name || formData?.email) {
      sessionService.updateUserInfo(formData.name, formData.email);
    }
  }, [formData?.name, formData?.email]);
}
